import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectStoreType, setStoreType, StoreTypeFilter } from '../state/filtersSlice';
import { formatInt } from '../utils/format';
import './su-components.css';

export interface StoreFilterBarProps {
  /** Total store count shown in "All Stores (n)". */
  count?: number | null;
  /** Controlled mode; defaults to the filters slice. */
  value?: StoreTypeFilter;
  onChange?: (v: StoreTypeFilter) => void;
}

const OPTIONS: Array<{ value: StoreTypeFilter; label: string }> = [
  { value: 'all', label: 'All Stores' },
  { value: 'PTL', label: 'PTL' },
  { value: 'LTL', label: 'LTL' },
  { value: 'NEW_STORE', label: 'New Stores' },
];

/** One-tap store type selection: four options in a single box, the selected one highlighted. */
const StoreFilterBar: React.FC<StoreFilterBarProps> = ({ count, value, onChange }) => {
  const dispatch = useDispatch();
  const sliceValue = useSelector((s: any) => selectStoreType(s));
  const current = value ?? sliceValue;
  const handle = (v: StoreTypeFilter) => (onChange ? onChange(v) : dispatch(setStoreType(v)));
  return (
    <div className="su-storefilter" role="radiogroup" aria-label="Store type">
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={o.value === current}
          className={`su-storefilter-opt${o.value === current ? ' active' : ''}`}
          onClick={() => o.value !== current && handle(o.value)}
        >
          {o.value === 'all' && count != null ? `${o.label} (${formatInt(count)})` : o.label}
        </button>
      ))}
    </div>
  );
};

export default StoreFilterBar;
